import { createFileRoute } from "@tanstack/react-router";
import Reembolso from "../pages/Reembolso";

export const Route = createFileRoute("/reembolso")({
  component: Reembolso,
});
